import config from '@/config'

const addisonResourceUrl = `${config.resourceHost}oauth2/addison`

export default {
  endpoints: {
    authUrl: `${addisonResourceUrl}`,
    authStatus: `${addisonResourceUrl}/status`,
    revoke: `${addisonResourceUrl}/revoke`,
  },
}
